import * as React from 'react';
export const suntrustSvg = React.forwardRef(function suntrustSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#002184',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm5.76 17.784-.13.36c-.1.3-.11.82-.04 1.1l.63 3.38c.05.29.14.41.24.4.1-.03.09-.26.03-.76l-.48-4.48c-.02-.28-.15-.28-.25 0m1.33 3.55c.01.3.04.64-.05.66-.1.02-.15-.09-.2-.47l-.2-1.99c-.03-.28.01-.89.12-1.1.1-.21.2-.16.2.13l.13 2.77zm.86-6.7-.25 5.8c0 .26-.02.6-.11.58-.06-.01-.12-.17-.13-.43l-.1-4.77c-.01-.24.08-.63.2-.86l.17-.33c.12-.23.24-.23.22 0m.84 1.2-.38 4.42c-.04.31-.09.63-.17.63-.06 0-.12-.2-.09-.49l.16-3.8c.03-.27.2-.69.32-.9.11-.2.2-.11.16.13m.14 4.12c-.07-.01-.07-.33-.05-.54l.6-6.13c.03-.22.19-.57.35-.77l.05-.08c.17-.2.29-.18.24.04l-1 6.95c-.06.3-.1.53-.19.53m1.79-6.47c.13-.15.35-.07.3.15l-1.3 6.2c-.05.22-.15.56-.25.55-.08-.01-.07-.34-.01-.6l.94-5.6c.05-.22.18-.55.32-.7m.13 6.27c-.1.22-.21.52-.34.46-.1-.04.1-.52.1-.52l3.24-8.2c.1-.24.34-.55.59-.42.23.11-.02.57-.1.78-1.97 4.59-2.54 5.77-3.49 7.9m.73-.4c.08.06.26-.17.4-.42l5.95-10.26c.1-.19.16-.48-.05-.6-.17-.08-.46.09-.6.34l-5.51 10.33c-.16.31-.25.55-.18.6m.14 1.11c-.08-.08.05-.33.21-.58l6.35-9.55c.17-.27.55-.57.78-.43.21.13.21.4.04.65l-6.93 9.5c-.17.26-.37.5-.45.41m1.88-1.1s-.42.45-.51.35c-.1-.1.08-.29.26-.53l.21-.26 8.86-10.55c.14-.18.34-.19.53-.04l.26.34a.5.5 0 0 1-.02.64l-9.61 10.05zm-.72 1.69c-.07-.07.08-.29.36-.54l9.42-8.97c.17-.18.4-.18.56-.02.2.2.26.37.3.55.05.28-.1.4-.3.58l-9.8 8.1c-.25.22-.46.37-.54.3m1.95-.8 10.95-8.12c.21-.17.4-.13.46.08l.25.91c.06.23-.1.53-.32.7l-11.16 6.69c-.28.18-.56.34-.63.24-.09-.12.19-.3.44-.5m-1.17 1.7c-.03-.13.26-.26.56-.42l9.8-5.12c.27-.15.48-.08.48.16l.05 1.13c0 .25-.26.55-.56.68l-9.67 3.48c-.33.14-.63.22-.66.09m11.5-.97-9.48 1.4c-.37.06-.64.12-.67.01-.03-.14.29-.22.63-.34l9.83-3.1c.31-.1.56.02.53.27l-.14 1.17c-.03.27-.35.53-.7.59m-10.79 2.35c-.03-.14.45-.22.8-.26l8.38-1.02c.38-.04.68.17.56.5l-.17.46c-.1.3-.4.5-.8.47h-8c-.35 0-.72 0-.75-.15m-1.17-12.86s-2.42 7.72-2.56 8.13c-.15.45-.3.84-.42.81-.08-.02-.02-.3.07-.65l2.3-8.38c.1-.34.45-.63.58-.6.24.05.1.47.03.69',
        fill: '#FFF',
      }),
    ),
  );
});
suntrustSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var suntrust = {
  category: 'brand',
  colorable: false,
  name: 'suntrust',
  svg: suntrustSvg,
};
